import prototype from './prototype.png'

const content = `<p>The Prototype design pattern consists in separating generic code from specific type of objects to create, by giving to the generic code an object that has a <code>clone</code> method. This object with a <code>clone</code> method is called a prototype.</p>

<p>The instantiate objects, the generic code calls <code>clone</code> on the prototype. The prototype returns a copy of itself.</p>

<p>The generic code doesn’t know the type and value of the prototype. The only thing that the generic code knows about the prototype is that it has a <code>clone</code> method. That’s a usage of <a href="polymorphism">Polymorphism</a>, where the interface implemented by the prototype and called by the generic code is the <code>clone</code> function.</p>

<img src=${prototype} alt="prototype" />

<div class="notes">
<p>Key points</p>

<ul><li>Prototype allows to decouple generic code from the type of an object to create</li><li>It uses Polymorphism to let generic code call <code>clone</code> on the prototype</li><li>The prototype knows the type (and value) of the object to create by cloning itself</li></ul>
</div>`

export default content
